import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useElevate } from '../ElevateContext';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { ReactComponent as Cross } from '../../../svg/Cross26.svg';
import t from '@jetshop/intl';

const ExternalFacetChipsWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: inherit;
  flex-wrap: wrap;
  align-items: center;
`;

const ExternalFacetChip = styled('button')`
  display: inline-flex;
  align-items: center;
  background: #eee6de;
  color: ${theme.colors.primary};
  border: 1px solid #eee6de;
  padding: 0 10px 0 16px;
  font-size: 0.85rem;
  font-weight: normal;
  font-family: ${theme.fonts.primary};
  line-height: 1.3;
  max-width: 180px;
  height: 44px;

  .chip-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 6px;
    font-size: 1rem;
    margin-top: 2px;
  }

  .chip-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: transparent;

    cursor: pointer;
    transition: all 0.2s ease;

    /* Better focus state for accessibility */
    &:focus {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 2px;
      background: ${theme.colors.darkgrey}60;
    }

    &:hover {
      background: ${theme.colors.darkgrey}60;
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }

    svg {
      width: 24px;
      height: 24px;
      color: ${theme.colors.primary};
    }
  }

  &.clear-all-button {
    svg {
      color: #e74c3c;
    }
  }
`;

export const ElevateActiveFacets = ({ facets }) => {
  // TODO: handle range facets
  const { removeFacetValue, getActiveFacets, clearAllFacets } = useElevate();
  const history = useHistory();

  const [activeFacets, setActiveFacets] = useState([]);
  useEffect(() => {
    const aFacets = getActiveFacets(facets);
    setActiveFacets(aFacets);
  }, [facets, history.location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  if (activeFacets.length === 0) {
    return null;
  }

  return (
    <ExternalFacetChipsWrapper>
      {activeFacets?.map(({ facetId, valueId, valueLabel, key }) => (
        <ExternalFacetChip
          key={key}
          onClick={() => removeFacetValue(facetId, valueId)}
          title={`Remove ${valueLabel} filter`} // TODO: translate
          aria-label={`Remove ${valueLabel} filter`} // TODO: translate
          type="button"
        >
          <span className="chip-label" title={valueLabel}>
            {valueLabel}
          </span>
          <div className="chip-remove">
            <Cross />
          </div>
        </ExternalFacetChip>
      ))}
      <ExternalFacetChip
        onClick={clearAllFacets}
        title={t('Clear all')} // TODO: translate
        aria-label={'Clear all filters'} // TODO: translate
        type="button"
        className="clear-all-button"
      >
        <span className="chip-label">{t('Clear all')}</span>
        <div className="chip-remove">
          <Cross />
        </div>
      </ExternalFacetChip>
    </ExternalFacetChipsWrapper>
  );
};
